import { useEffect, useState } from 'react';

import {
  CustomerInbodyAccount,
  InbodyAccountInfo,
} from '../../../interfaces/customerInbodyAccount';
import { nutritionCustomerInbodyAccountService } from '../../../services/customerInbodyAccountService/nutritionCustomerInbodyAccountService';
import { scanIqCustomerInbodyAccountService } from '../../../services/customerInbodyAccountService/scanIqCustomerInbodyAccountService';
import { CustomerInbodyAccountService } from '../../../services/customerInbodyAccountService/customerInbodyAccountService';
import { updateItemByField } from '../../../../shared/utils/arrayUtils';
import {
  CUSTOMER_TYPE,
  CustomerType,
} from '../../../../shared/constants/customer/customerType';

type UseCustomerInbodyAccountsReturn = {
  inbodyAccounts: CustomerInbodyAccount[];
  handleRefreshInbodyAccountData: (accountInfo: InbodyAccountInfo) => Promise<void>;
  handleRequestInbodyAccountAccess: (accountInfo: InbodyAccountInfo) => Promise<void>;
};

const serviceConfig: Record<CustomerType, CustomerInbodyAccountService> = {
  [CUSTOMER_TYPE.NUTRITION]: nutritionCustomerInbodyAccountService,
  [CUSTOMER_TYPE.SCAN_IQ]: scanIqCustomerInbodyAccountService,
};

export const useCustomerInbodyAccounts = (
  customerId: number,
  customerType: CustomerType,
  entityId?: number,
): UseCustomerInbodyAccountsReturn => {
  const service = serviceConfig[customerType];

  const [inbodyAccounts, setInbodyAccounts] = useState<CustomerInbodyAccount[]>([]);

  const getInbodyAccounts = async () => {
    const { customerInbodyAccounts } = await service.getCustomerInbodyAccounts(
      customerId,
      entityId,
    );

    setInbodyAccounts(customerInbodyAccounts);
  };

  useEffect(() => {
    getInbodyAccounts();
  }, [customerId, customerType, entityId]);

  const updateInbodyAccount = (account: CustomerInbodyAccount) => {
    setInbodyAccounts((accounts) =>
      updateItemByField(accounts, account, {
        inbodyKeyId: account.inbodyKeyId,
      }),
    );
  };

  const handleRefreshInbodyAccountData = async (accountInfo: InbodyAccountInfo) => {
    const account = await service.refreshCustomerInbodyAccount(
      customerId,
      accountInfo,
      entityId,
    );

    updateInbodyAccount(account);
  };

  const handleRequestInbodyAccountAccess = async (accountInfo: InbodyAccountInfo) => {
    const account = await service.requestInbodyAccountAccess(
      customerId,
      accountInfo,
      entityId,
    );

    updateInbodyAccount(account);
  };

  return {
    inbodyAccounts,
    handleRefreshInbodyAccountData,
    handleRequestInbodyAccountAccess,
  };
};
